// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/pages/style/my-fields.css */

/* Импортируем шрифт для футуристичного/минималистичного вида */

/* Глобальные сбросы и базовые стили */
*, *::before, *::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  padding: 0;
  font-family: 'Inter', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.my-fields-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  background-color: #0a0a1a;
  color: #e0e0e0;
}

.my-fields-header {
  background-color: #1a0f2b;
  color: #f0f0f0;
  padding: 20px 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 0 15px rgba(147, 112, 219, 0.4);
  border-bottom: 1px solid rgba(147, 112, 219, 0.2);
}

.my-fields-header .page-title {
  margin: 0;
  font-size: 2.5em;
  font-weight: 700;
  letter-spacing: 1.5px;
  text-shadow: 0 0 10px rgba(147, 112, 219, 0.7);
  color: #9370DB;
}

.profile-button, .add-field-button {
  background: linear-gradient(45deg, #8A2BE2, #9370DB);
  color: white;
  padding: 12px 22px;
  border: none;
  border-radius: 8px;
  font-size: 1em;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.3);
  display: flex;
  align-items: center;
  gap: 8px;
}

.add-field-button {
  background: linear-gradient(45deg, #7B68EE, #8A2BE2);
  margin-right: 15px;
}

.profile-button .button-icon, .add-field-button .button-icon {
  font-size: 1.2em;
}

.profile-button:hover, .add-field-button:hover {
  background: linear-gradient(45deg, #9370DB, #8A2BE2);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.5);
}

.profile-button:active, .add-field-button:active {
  transform: translateY(0);
  box-shadow: 0 3px 10px rgba(138, 43, 226, 0.3);
}

.my-fields-main-content {
  flex-grow: 1;
  padding: 40px 20px;
  max-width: 800px;
  width: 100%;
  margin: 0 auto;
}

.fields-section {
  margin-bottom: 40px;
}

.fields-section h2 {
  color: #9370DB;
  font-size: 1.8em;
  margin-bottom: 20px;
  text-shadow: 0 0 8px rgba(147, 112, 219, 0.6);
  padding-bottom: 10px;
  border-bottom: 1px solid rgba(147, 112, 219, 0.3);
}

.fields-list-container {
  background-color: rgba(20, 0, 40, 0.8);
  padding: 30px;
  border-radius: 12px;
  box-shadow: 0 0 40px rgba(138, 43, 226, 0.4),
              inset 0 0 15px rgba(147, 112, 219, 0.2);
  border: 1px solid rgba(147, 112, 219, 0.3);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
}

.loading-message,
.error-message,
.no-fields-message {
  font-size: 1.1em;
  color: #c0c0c0;
  padding: 20px;
  border-radius: 8px;
  background-color: rgba(30, 10, 50, 0.6);
  border: 1px solid rgba(147, 112, 219, 0.3);
}

.error-message {
  color: #ff6b6b;
  border-color: #ff6b6b;
  box-shadow: 0 0 15px rgba(255, 107, 107, 0.3);
}

.field-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.field-item {
  background-color: rgba(30, 5, 60, 0.7);
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(147, 112, 219, 0.2);
}

.field-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 25px rgba(138, 43, 226, 0.4),
              inset 0 0 10px rgba(147, 112, 219, 0.3);
}

.field-link {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 25px;
  text-decoration: none;
  color: #f0f0f0;
  font-size: 1.2em;
  font-weight: 600;
  transition: color 0.3s ease;
}

.field-link:hover {
  color: #8A2BE2;
}

.field-name {
  flex-grow: 1;
  text-align: left;
  letter-spacing: 0.8px;
  text-shadow: 0 0 5px rgba(147, 112, 219, 0.3);
}

.arrow-icon {
  font-size: 1.5em;
  color: #9370DB;
  transition: transform 0.3s ease, color 0.3s ease;
}

.field-item:hover .arrow-icon {
  transform: translateX(5px);
  color: #8A2BE2;
}

/* Адаптивность для маленьких экранов */
@media (max-width: 768px) {
  .my-fields-header {
    flex-direction: column;
    align-items: flex-start;
    padding: 15px 20px;
    gap: 15px;
  }

  .my-fields-header .page-title {
    font-size: 2em;
  }

  .profile-button, .add-field-button {
    align-self: stretch;
    padding: 10px 18px;
    font-size: 0.9em;
    justify-content: center;
  }

  .my-fields-main-content {
    padding: 20px 10px;
  }

  .fields-list-container {
    padding: 25px 15px;
  }

  .field-link {
    padding: 15px 20px;
    font-size: 1.1em;
  }
}

@media (max-width: 480px) {
  .my-fields-header .page-title {
    font-size: 1.8em;
  }

  .profile-button, .add-field-button {
    font-size: 0.85em;
    padding: 8px 15px;
  }

  .fields-list-container {
    padding: 20px 12px;
  }

  .field-link {
    font-size: 1em;
    padding: 12px 15px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/style/my-fields.css"],"names":[],"mappings":"AAAA,kCAAkC;;AAElC,+DAA+D;;AAG/D,sCAAsC;AACtC;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,gCAAgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6CAA6C;EAC7C,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;EACrB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE,oDAAoD;EACpD,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,8CAA8C;EAC9C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oDAAoD;EACpD,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;EACpD,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,6CAA6C;EAC7C,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB;qDACmD;EACnD,0CAA0C;EAC1C,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;;EAGE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,gBAAgB;EAChB,qDAAqD;EACrD,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;EAC3B;qDACmD;AACrD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;AACF","sourcesContent":["/* src/pages/style/my-fields.css */\n\n/* Импортируем шрифт для футуристичного/минималистичного вида */\n@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;700&display=swap');\n\n/* Глобальные сбросы и базовые стили */\n*, *::before, *::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  font-family: 'Inter', sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.my-fields-page {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  background-color: #0a0a1a;\n  color: #e0e0e0;\n}\n\n.my-fields-header {\n  background-color: #1a0f2b;\n  color: #f0f0f0;\n  padding: 20px 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: 0 0 15px rgba(147, 112, 219, 0.4);\n  border-bottom: 1px solid rgba(147, 112, 219, 0.2);\n}\n\n.my-fields-header .page-title {\n  margin: 0;\n  font-size: 2.5em;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  text-shadow: 0 0 10px rgba(147, 112, 219, 0.7);\n  color: #9370DB;\n}\n\n.profile-button, .add-field-button {\n  background: linear-gradient(45deg, #8A2BE2, #9370DB);\n  color: white;\n  padding: 12px 22px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1em;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: 0 5px 15px rgba(138, 43, 226, 0.3);\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.add-field-button {\n  background: linear-gradient(45deg, #7B68EE, #8A2BE2);\n  margin-right: 15px;\n}\n\n.profile-button .button-icon, .add-field-button .button-icon {\n  font-size: 1.2em;\n}\n\n.profile-button:hover, .add-field-button:hover {\n  background: linear-gradient(45deg, #9370DB, #8A2BE2);\n  transform: translateY(-2px);\n  box-shadow: 0 8px 20px rgba(138, 43, 226, 0.5);\n}\n\n.profile-button:active, .add-field-button:active {\n  transform: translateY(0);\n  box-shadow: 0 3px 10px rgba(138, 43, 226, 0.3);\n}\n\n.my-fields-main-content {\n  flex-grow: 1;\n  padding: 40px 20px;\n  max-width: 800px;\n  width: 100%;\n  margin: 0 auto;\n}\n\n.fields-section {\n  margin-bottom: 40px;\n}\n\n.fields-section h2 {\n  color: #9370DB;\n  font-size: 1.8em;\n  margin-bottom: 20px;\n  text-shadow: 0 0 8px rgba(147, 112, 219, 0.6);\n  padding-bottom: 10px;\n  border-bottom: 1px solid rgba(147, 112, 219, 0.3);\n}\n\n.fields-list-container {\n  background-color: rgba(20, 0, 40, 0.8);\n  padding: 30px;\n  border-radius: 12px;\n  box-shadow: 0 0 40px rgba(138, 43, 226, 0.4),\n              inset 0 0 15px rgba(147, 112, 219, 0.2);\n  border: 1px solid rgba(147, 112, 219, 0.3);\n  backdrop-filter: blur(5px);\n  -webkit-backdrop-filter: blur(5px);\n}\n\n.loading-message,\n.error-message,\n.no-fields-message {\n  font-size: 1.1em;\n  color: #c0c0c0;\n  padding: 20px;\n  border-radius: 8px;\n  background-color: rgba(30, 10, 50, 0.6);\n  border: 1px solid rgba(147, 112, 219, 0.3);\n}\n\n.error-message {\n  color: #ff6b6b;\n  border-color: #ff6b6b;\n  box-shadow: 0 0 15px rgba(255, 107, 107, 0.3);\n}\n\n.field-list {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n}\n\n.field-item {\n  background-color: rgba(30, 5, 60, 0.7);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(147, 112, 219, 0.2);\n}\n\n.field-item:hover {\n  transform: translateY(-5px);\n  box-shadow: 0 10px 25px rgba(138, 43, 226, 0.4),\n              inset 0 0 10px rgba(147, 112, 219, 0.3);\n}\n\n.field-link {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px 25px;\n  text-decoration: none;\n  color: #f0f0f0;\n  font-size: 1.2em;\n  font-weight: 600;\n  transition: color 0.3s ease;\n}\n\n.field-link:hover {\n  color: #8A2BE2;\n}\n\n.field-name {\n  flex-grow: 1;\n  text-align: left;\n  letter-spacing: 0.8px;\n  text-shadow: 0 0 5px rgba(147, 112, 219, 0.3);\n}\n\n.arrow-icon {\n  font-size: 1.5em;\n  color: #9370DB;\n  transition: transform 0.3s ease, color 0.3s ease;\n}\n\n.field-item:hover .arrow-icon {\n  transform: translateX(5px);\n  color: #8A2BE2;\n}\n\n/* Адаптивность для маленьких экранов */\n@media (max-width: 768px) {\n  .my-fields-header {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 15px 20px;\n    gap: 15px;\n  }\n\n  .my-fields-header .page-title {\n    font-size: 2em;\n  }\n\n  .profile-button, .add-field-button {\n    align-self: stretch;\n    padding: 10px 18px;\n    font-size: 0.9em;\n    justify-content: center;\n  }\n\n  .my-fields-main-content {\n    padding: 20px 10px;\n  }\n\n  .fields-list-container {\n    padding: 25px 15px;\n  }\n\n  .field-link {\n    padding: 15px 20px;\n    font-size: 1.1em;\n  }\n}\n\n@media (max-width: 480px) {\n  .my-fields-header .page-title {\n    font-size: 1.8em;\n  }\n\n  .profile-button, .add-field-button {\n    font-size: 0.85em;\n    padding: 8px 15px;\n  }\n\n  .fields-list-container {\n    padding: 20px 12px;\n  }\n\n  .field-link {\n    font-size: 1em;\n    padding: 12px 15px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
